import { Component, OnInit } from '@angular/core';
import { Auth } from 'src/app/models/auth';
import { CardPaged } from 'src/app/models/response/card-paged';
import { CartaoStatusResponseModel } from 'src/app/models/response/cartao-status-response-model';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CartaoService } from 'src/app/services/cartao.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';

@Component({
  selector: 'app-cartao-status-list',
  templateUrl: './cartao-status-list.component.html',
  styleUrls: ['./cartao-status-list.component.css']
})
export class CartaoStatusListComponent implements OnInit {

  public cards: CartaoStatusResponseModel[] = [];
  public currentUser: Auth;

  // páginação
  currentPage = 1;
  showItem = '10';
  totalItems = 0;

  constructor(
    private alertService: NewAlertService,
    private cartaoService: CartaoService,
    private authenticationService: AuthenticationService
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
  }

  ngOnInit() {
    this.pageChangedGateway(1);
  }

  pageChangedGateway(event) {
    this.currentPage = event;
    const offset = this.currentPage - 1;

    this.alertService.clear();

    this.cartaoService
        .getAllCardPaged(this.currentUser.token.assignorGuid, offset, +this.showItem)
        .subscribe(
          response => {
              if (response.status === ApiError.Sucesso) {
                this.cards = response.result.cards;

                this.totalItems = response.result.totalResults;
              } else {
                this.alertService.error(response.message);
              }
            },
            error => {
              this.alertService.error(
                'Ocorreu um erro ao paginar os cartões'
              );
            }
        );
  }

  showItemChanged(event) {
    this.showItem = event;
    this.pageChangedGateway(1);
  }

}
